import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import { PAGE_TYPE, setPageTitle } from "containers/App/reducer";

import { getIsTableauLoading } from "containers/Login/reducer";
import { getIsTableauMode, getIsGoogleMode } from "containers/App/reducer";
import * as viewReducer from "containers/View/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as foldersReducer from "containers/Folders/reducer";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import LookerSettingsModalContainer from "containers/LookerSettings/LookerSettingsModal";
import WizardContainer from "containers/Wizard/Wizard";
import ConsumerContainer from "containers/Consumer/Consumer";
import GoogleSheetsHome from "containers/Next/Google/GoogleSheetsHome";

import Home from "components/Home/Home";

import { isEnabled } from "utils/featureFlags";

class HomeContainer extends React.PureComponent {
  componentDidMount() {
    setPageTitle(PAGE_TYPE.HOME);
  }

  render() {
    const {
      isTableauMode,
      isTableauLoading,
      isGoogleMode,
      isLookerMode,
      type,
      search,
      moveBlueprintId,
      moveReportId,
      headerMode,
      updateMoveBlueprintId,
      handleMoveReport
    } = this.props;

    if (isGoogleMode) {
      return <GoogleSheetsHome />;
    }

    return (isTableauMode && isTableauLoading) || isLookerMode ? (
      <div
        style={{
          height: "calc(100vh - 60px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <LoadingIndicator style={{ margin: "0px" }} />
      </div>
    ) : isEnabled("aible-consumer") ? (
      <ConsumerContainer />
    ) : isTableauMode && false ? (
      <WizardContainer id="new" isDeployList />
    ) : (
      <React.Fragment>
        <LookerSettingsModalContainer />
        <Home
          type={type}
          search={search}
          headerMode={headerMode}
          moveBlueprintId={moveBlueprintId}
          updateMoveBlueprintId={updateMoveBlueprintId}
          moveReportId={moveReportId}
          handleMoveReport={handleMoveReport}
        />
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateMoveBlueprintId: (blueprintId) => dispatch(foldersReducer.updateMoveBlueprintId(blueprintId)),
  handleMoveReport: (reportId) => dispatch(foldersReducer.handleMoveReport(reportId))
});

const mapStateToProps = (state) => ({
  isTableauMode: getIsTableauMode(state),
  isGoogleMode: getIsGoogleMode(state),
  isTableauLoading: getIsTableauLoading(state),
  type: viewReducer.getType(state),
  search: viewReducer.getSearch(state),
  moveBlueprintId: foldersReducer.getMoveBlueprintId(state),
  moveReportId: foldersReducer.getMoveReportId(state),
  headerMode: viewReducer.getHeaderMode(state),
  isLookerMode: loginReducer.getLookerAPIClient(state) !== undefined
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(HomeContainer);
export { mapDispatchToProps };
